import { initMarker, googleMapsReady, loadGoogleMapsWhenNeeded } from "./googleMaps";

export default async function googleMapsAddressSearch() {
    const fields = document.querySelectorAll('[data-address-search]');

    if (!fields.length) {
        return;
    }

    loadGoogleMapsWhenNeeded();

    try {
        await googleMapsReady;

        fields.forEach(function (field) {
            const name = field.getAttribute('data-address-search');
            const map = window.LandedHouses.maps[name];

            let autocomplete = new google.maps.places.Autocomplete(field, {
                componentRestrictions: { country: ["uk"] },
            });

            autocomplete.addListener("place_changed", function () {
                const place = autocomplete.getPlace();
                const coords = place.geometry.location.toJSON();

                map.setCenter(coords);
                map.setZoom(13);

                map.markers.forEach(function (marker) {
                    marker.setMap(null);
                });

                initMarker({
                    lat: coords.lat,
                    lng: coords.lng,
                }, null, map);

                window.dispatchEvent(new CustomEvent('landedHouses/googleMaps/addressSearch', {
                    detail: {
                        placeId: place.place_id,
                        name: name,
                        address: place.formatted_address,
                        coords: coords,
                    },
                }));
            });
        });
    } catch (error) {
        console.error('Google Maps address search failed to initialise:', error);
    }
}
